<p>update-primary-phone works!</p>
